import { IFRAME_MESSAGE_TYPES } from "@apollosproject/canvas-ui-web/utils/embedPostMessage.js";

export { IFRAME_MESSAGE_TYPES };

/**
 * Ask the parent embed host to close the modal. No-op when not embedded
 * (`window.parent === window`), so callers can invoke it unconditionally and
 * pair it with a non-embed navigation fallback.
 */
export function requestEmbedClose() {
  if (typeof window === "undefined") return;
  if (window.parent !== window) {
    window.parent.postMessage(
      { type: IFRAME_MESSAGE_TYPES.REQUEST_CLOSE },
      "*"
    );
  }
}

/**
 * Ask the parent embed host to toggle fullscreen. No-op when not embedded.
 */
export function requestEmbedFullscreen() {
  if (typeof window === "undefined") return;
  if (window.parent !== window) {
    window.parent.postMessage(
      { type: IFRAME_MESSAGE_TYPES.REQUEST_FULLSCREEN },
      "*"
    );
  }
}
